
import { NgModule } from '@angular/core';

import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { NewloginComponent } from './newlogin/newlogin.component';

import { AuthGuard } from './../service/auth.guard';
const routes: Routes = [
  
  // {
  //   path: '',
  //   redirectTo: 'home',
  //   pathMatch: 'full'
  // },
  { path: '', component: NewloginComponent },
  { path: 'signin', component: NewloginComponent },
  // {
  //   path: 'signup',
  //   loadChildren: () => import('./signup/signup.module').then( m => m.SignupPageModule)
  // },

  // {
  //   path: 'signin',
  //   loadChildren: () => import('./signin/signin.module').then( m => m.SigninPageModule)
  // },
  // {
  //   path: 'welcome',
  //   loadChildren: () => import('./welcome/welcome.module').then( m => m.WelcomePageModule),
  //   data: { preload: true }, canLoad: [AuthGuard] 
  // },
  {
    path: 'main-home', 
    loadChildren: () => import('./pages/aggrid/aggrid.module').then( m => m.AggridPageModule),
    canActivate: [AuthGuard]
      //  loadChildren: () => import('./main-home/main-home.module').then( m => m.MainHomePageModule),    data: { preload: true }, canLoad: [AuthGuard] 
  },
  {
    path: 'aggrid',
    loadChildren: () => import('./pages/aggrid/aggrid.module').then( m => m.AggridPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'defailinfo/:stock/:qty',
    loadChildren: () => import('./pages/defailinfo/defailinfo.module').then( m => m.DefailinfoPageModule),
    canActivate: [AuthGuard]  
  },

  // {
  //   path: 'changepassword',
  //   loadChildren: () => import('./changepassword/changepassword.module').then( m => m.ChangepasswordPageModule) , data: { preload: true }, canLoad: [AuthGuard] 
  // },
  {
    path: 'index',
    loadChildren: () => import  ('./pages/index/index.module').then( m => m.IndexPageModule) ,  
    canActivate: [AuthGuard]
  },
  {
    path: 'analytical',
    loadChildren: () => import('./pages/stocks/stocks.module').then( m => m.StocksPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'analytical/:para',
    loadChildren: () => import('./pages/stocks/stocks.module').then( m => m.StocksPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/setting/setting.module').then( m => m.SettingPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'hedge',
    loadChildren: () => import('./pages/hedge/hedge.module').then( m => m.HedgePageModule),
    canActivate: [AuthGuard]        
  },      
   {
    path: 'volatility',
    loadChildren: () => import('./pages/volatility/volatility.module').then( m => m.VolatilityPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sharedata',
    loadChildren: () => import('./pages/sharedata/sharedata.module').then( m => m.SharedataPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'analyticaldtl',
    loadChildren: () => import('./pages/stockdetails/stockdetails.module').then( m => m.StockdetailsPageModule),
    canActivate: [AuthGuard]
  },
  {     
    path: 'addst',
    loadChildren: () => import('./pages/add/add.module').then( m => m.AddPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Anyst/:stock',
    loadChildren: () => import('./pages/detail/detail.module').then( m => m.DetailModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'volatility',
    loadChildren: () => import('./pages/volatility/volatility.module').then( m => m.VolatilityPageModule),
    canActivate: [AuthGuard]
  },
 {  
    path: 'autotrade',
    loadChildren: () => import('./pages/autotrade/autotrade.module').then(m => m.AutoTradePageModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'commodity/setting',
    loadChildren: () => import('./pages/commodity-setting/commodity-setting.module').then( m => m.CommoditySettingPageModule),
    canActivate: [AuthGuard]
  } ,
  {
    path: 'crypto/setting',
    loadChildren: () => import('./pages/crypto-setting/crypto-setting.module').then( m => m.CryptoSettingPageModule),
    canActivate: [AuthGuard]
  } ,
  {
    path: 'crypto/scanner',
    loadChildren: () => import('./pages/crypto-scanner/crypto-scanner.module').then( m => m.CryptoScannerPageModule),
    canActivate: [AuthGuard]
  } ,
  {
    path: 'crypto/trades',
    loadChildren: () => import('./pages/crypto-trades/crypto-trades.module').then( m => m.CryptoTradesPageModule),
    canActivate: [AuthGuard]
  } ,
  {
    path: 'crypto/ratio-spread',
    loadChildren: () => import('./pages/ratio-spread/ratio-spread.module').then( m => m.RatioSpreadPageModule),
    canActivate: [AuthGuard]
  } ,
   {
    path: 'commodity/:para',
    loadChildren: () => import('./pages/commodity/commodity.module').then( m => m.CommodityPageModule), 
    canActivate: [AuthGuard]
  },

  {
    path: 'positions',
    loadChildren: () => import('./pages/positions/positions.module').then( m => m.PositionsPageModule),
    canActivate: [AuthGuard]  
  },
  {
    path: 'engine-health',
    loadChildren: () => import('./pages/engine-health/engine-health.module').then( m => m.EngineHealthPageModule)
  },
  {
    path: 'service-status',
    loadChildren: () => import('./pages/service-status/service-status.module').then( m => m.ServiceStatusPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mcxauto',
    loadChildren: () => import('./pages/mcxauto/mcxauto.module').then( m => m.McxautoPageModule)
  },
  {
    path: 'chaser',
    loadChildren: () => import('./pages/chaser/chaser.module').then( m => m.ChaserPageModule)
  },
  // {
  //   path: 'Chart',
  //   loadChildren: () => import('./spending-month/spending-month.module').then( m => m.SpendingMonthPageModule)
  // },
 
 
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// { path: 'add-accounts/:id',   component: AccountsComponent, canLoad: [AuthGuard]  },
// { path: 'add-accounts/new',   component: AccountsComponent, canLoad: [AuthGuard]  },